import React from 'react';
import ReactDOM from 'react-dom';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import AppView from './ui/AppView';
import AppWithFeeds from './AppWithFeeds';


const App: React.FC = () => {
  if(process.env.REACT_APP_SHOW_FEEDS){
    return <AppWithFeeds/>;
  }
  return <AppView/>;
};

export function renderApp (rootElement: Element | null, reduxStore: Store) {
  ReactDOM.render(
    <Provider store={reduxStore}>
      <App />
    </Provider>,
    rootElement
  );
}

export default renderApp;